import useAuth from "containers/auth/useHooks";
import React, { useEffect, useState } from "react";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noPrivacyPolicyFound from "assets/images/gifs/privacypolicy-not-found.gif";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  content?: {
    id: number;
    heading: string;
    content: string;
    createdAt: string;
    updatedAt: string;
  }[];
}

const PrivacyPolicy: React.FC<DrawerProps> = ({ isOpen, onClose, content }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const { getPrivacyPolicy } = useAuth();
  // const [termConditionContent, setTermConditionContent] = useState<[]>([]);
  const [privacyPolicyContent, setPrivacyPolicyContent] = useState<[]>([]);

  useEffect(() => {
    // getPrivacyPolicy({ heading: 'Host User Agreement' }, setTermConditionContent);
    getPrivacyPolicy({ heading: "Privacy Policy" }, setPrivacyPolicyContent);
  }, []);

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-drawer) + 1)' }}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto custom-scrollbar bg-white p-4 md:p-10 md:shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black z-10"
        >
          &times;
        </button>
        
        {/* Content display */}
        {(content && content.length > 0) || (privacyPolicyContent && privacyPolicyContent.length > 0) ? (
          <>
            {content && content.length > 0
              ? content.map((item: any) => (
                  <div key={item.id} className="space-y-4">
                    <h2 className="text-2xl font-bold text-black mb-4">
                      {item.heading}
                    </h2>
                    <div
                      className="html-content text-labelTextColor text-sm"
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </div>
                ))
              : privacyPolicyContent?.map((item: any) => (
                  <div key={item.id} className="space-y-4">
                    <h2 className="text-2xl font-bold text-black mb-4">
                      {item.heading}
                    </h2>
                    <div
                      className="html-content text-labelTextColor text-sm"
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </div>
                ))}
          </>
        ) : (
          <div className="flex items-center justify-center h-full min-h-[50vh]">
            <CustomMessageDisplay
              show={!content?.length && !privacyPolicyContent?.length}
              title="No Privacy Policy Available"
              slogan="Privacy policy content is not available at the moment. Please check back later."
              image={noPrivacyPolicyFound}
              imageAlt="No content found"
              className="py-16"
              imageClassName="w-[150px] h-[120px]"
              titleClassName="text-2xl font-bold text-blackie"
              sloganClassName="text-gray-500 text-base max-w-md"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
